import { Tag } from "antd";
import React from "react";
import appConfig from "../../../../config/config.json";
import {
  CheckCircleOutlined,
  ExclamationCircleOutlined,
  MinusCircleOutlined,
} from "@ant-design/icons";
import { numberWithCommas } from "../../../../config/helpers/app/numberFormater";

const AdvanceAccountabilityFormOtherDetails = ({ data }) => {
  return (
    <div className="details_div">
      <table className="table table-striped table-hover">
        <thead>
          <tr>
            <th scope="col">Column</th>
            <th scope="col">Data</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Payment Voucher Number</td>
            <td>{data.id}</td>
          </tr>
          <tr>
            <td>Source Of Funds</td>
            <td>{data.projectDetails?.donor_name}</td>
          </tr>
          <tr>
            <td>Project</td>
            <td>{data.projectDetails?.project_name}</td>
          </tr>
          <tr>
            <td>Budget Line</td>
            <td>{data.budgetLineDetails?.name}</td>
          </tr>
          <tr>
            <td>Expense Code</td>
            <td>{data.budgetLineDetails?.expense_code}</td>
          </tr>
          <tr>
            <td>Account Type</td>
            <td>{data.paymentVoucherDetails?.type}</td>
          </tr>
          <tr>
            <td>Mode of Payment</td>
            <td>{data.paymentVoucherDetails?.mode_of_payment}</td>
          </tr>
          <tr>
            <td>Amount Advanced</td>
            <td>{numberWithCommas(data.amountAdvanced)}</td>
          </tr>
          <tr>
            <td>Requisition Form Number</td>
            <td>{data.requisitionMemoDetails?.memo_number}</td>
          </tr>
          <tr>
            <td>Status</td>
            <td>
              {data.status === appConfig.status.approved && (
                <Tag icon={<CheckCircleOutlined />} color="success">
                  {data.status}
                </Tag>
              )}
              {data.status === appConfig.status.checked && (
                <Tag icon={<MinusCircleOutlined />} color="processing">
                  {data.status}
                </Tag>
              )}
              {data.status === appConfig.status.created && (
                <Tag icon={<ExclamationCircleOutlined />} color="warning">
                  Pending
                </Tag>
              )}
              {data.status === appConfig.status.pending && (
                <Tag icon={<ExclamationCircleOutlined />} color="warning">
                  Pending
                </Tag>
              )}
            </td>
          </tr>

          <tr>
            <td>Created By</td>
            <td>{`${data?.creator?.first_name} ${data?.creator?.other_names}`}</td>
          </tr>
          <tr>
            <td>Created At</td>
            <td>
              {`${new Date(data.created_at).toDateString()} ${new Date(
                data.created_at
              ).toLocaleTimeString()}
                     `}
            </td>
          </tr>
          <tr>
            <td>Last Updated By</td>
            <td>
              {data.updator &&
                `${data?.updator?.first_name} ${data?.updator?.other_names}`}
            </td>
          </tr>
          <tr>
            <td>Last Updated At</td>
            <td>
              {data.updated_at &&
                `${new Date(data.updated_at).toDateString()} ${new Date(
                  data.updated_at
                ).toLocaleTimeString()}`}
            </td>
          </tr>
          <tr>
            <td>Checked By</td>
            <td>
              {data.checker &&
                `${data?.checker?.first_name} ${data?.checker?.other_names}`}
            </td>
          </tr>
          <tr>
            <td>Checked At</td>
            <td>
              {data.checked_at &&
                `${new Date(data.checked_at).toDateString()} ${new Date(
                  data.checked_at
                ).toLocaleTimeString()}
                     `}
            </td>
          </tr>
          <tr>
            <td>Approved By</td>
            <td>
              {data.approver &&
                `${data?.approver?.first_name} ${data?.approver?.other_names}`}
            </td>
          </tr>
          <tr>
            <td>Approved At</td>
            <td>
              {data.approved_at &&
                `${new Date(data.approved_at).toDateString()} ${new Date(
                  data.approved_at
                ).toLocaleTimeString()}`}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default AdvanceAccountabilityFormOtherDetails;
